import React, { useState, useEffect, useRef } from "react";
import {
  uploadMaterialData,
  addEmailRequest,
  getDownloadExportFile,
  getMCTTable,
  uploadBulkEmailRequests,
  getSampleUploadFile,
} from "../model/MatRequestModel";
// import { useToast } from "fe_comp_base";
import { useToast } from "../../../basecomp/components/provider/ToastProvider";
import { formattedDate } from "../model/MaterialCreationMethods";
import {
  CREATE_TYPE,
  EXTEND_TYPE,
  COPY_TYPE,
  MODIFY_TYPE,
  DELETE_TYPE,
  MPN_TYPE,
} from "../../assets/Strings";
import UserUtils from "../../../basecomp/auth/UserUtils";

const MatRequestVM = () => {
  const { getUserName } = UserUtils;
  const userName = getUserName();
  const { handleToastOpen } = useToast();
  const [selectedFiles, setSelectedFiles] = useState();
  const [selectedBulkFile, setSelectedBulkFile] = useState();
  const [isUploadSubmitting, setIsUploadSubmitting] = useState(false);

  const [selectedStatus, setSelectedStatus] = useState({
    type_of_request: "",
    status: "",
  });
  const [isTableVisible, setIsTableVisible] = useState(false);

  const [mctData, setMctData] = useState([]);
  const [searchValue, setSearchValue] = useState("");
  const [filteredList, setFilteredList] = useState([]);
  const [isUploading, setIsUploading] = useState(false);
  const [isEmailSubmitting, setIsEmailSubmitting] = useState(false);
  const [isLoading, setIsLoading] = useState(false);
  const [emailBulkLoading, setEmailBulkLoading] = useState(false);
  const [bulkCreationLoading, setBulkCreationLoading] = useState(false);



  
  const [emailFieldsForm, setEmailFieldsForm] = useState({
    material_number: {
      enter: "Material Number",
      isRequired: true,
    },
    description: {
      enter: "Description",
    },
    reason: {
      enter: "Reason",
      isRequired: true,
    },
    type_of_request: {
      enter: "Type of Request",
      isRequired: true,
      dropdownValues: [
        CREATE_TYPE,
        EXTEND_TYPE,
        COPY_TYPE,
        MODIFY_TYPE,
        DELETE_TYPE,
        MPN_TYPE,
      ],
    },
    plant_code: {
      enter: "Plant Id",
      isRequired: true,
    },
    mdm_name: {
      enter: "MDM Name",
      isRequired: true,
      value: userName,
    },
    status: {
      enter: "Status",
      dropdownValues: ["Approved", "Rejected"],
    },
    rejected_request_comments: {
      enter: "Rejected Request Comments",
    },
    date: {
      enter: "Date",
      isRequired: true,
      value: "",
    },
  });

 

  const handleFileChoose = (file) => {
    
    setSelectedFiles(file); // store single File object
  };

  const handleBulkFile = (files) => {
    setSelectedBulkFile(files);
  };
  
  const handleUpload = async () => {
  try {
    if (!selectedFiles) {
      handleToastOpen("error", "File is missing");
      return false;
    }

    setIsUploadSubmitting(true);
    const response = await uploadMaterialData(selectedFiles);

    const insertedCount =
      response?.data?.insertedNames?.filter(Boolean).length ?? 0;
    const rejectedCount = response?.data?.rejected ?? 0;
    const duplicateCount = response?.data?.Duplicates ?? 0;
    const totalProcessed = insertedCount + rejectedCount + duplicateCount;

    return {
      type: "success",
      success: insertedCount > 0,
      insertedCount,
      rejectedCount,
      duplicateCount,
      totalProcessed,
    };
  } catch (error) {
    if (
      error?.response?.status === 409 &&
      error.response.data?.hasDuplicates
    ) {
      return {
        type: "duplicate",
        message: error.response.data.message,
        duplicates: error.response.data.duplicates,
      };
    }

    handleToastOpen(
      "error",
      error.response?.data?.message || "File upload failed",
    );
    return false;
  } finally {
    setIsUploadSubmitting(false);
    setSelectedFiles(null);
    setIsTableVisible(true);
    // ── Don't await — let it refresh in background, don't block return ──
    // fetchTableData({ silent: true }); // ← removed `await`
    // ──────────────────────────────────────────────────────────────────
  }
};

 

  // const fetchTableData = React.useCallback(async ({ silent = false } = {}) => {
  //   try {
  //     if (!silent) setIsLoading(true);
  //     const response = await getMCTTable();
  //     const fresh = response.data;

  //     setMctData(fresh);
  //     setFilteredList(fresh);
  //     setIsTableVisible(true);
  //   } catch (error) {
  //     if (error?.response?.status === 429) {
        
  //       return;
  //     }
  //     if (!silent) handleToastOpen("error", error.message);
  //   } finally {
  //     if (!silent) setIsLoading(false);
  //   }
  // }, []); // ✅ stable reference — no stale closure
  // useEffect(() => {
  //   fetchTableData(); // initial load

  //   let interval;

  //   const startPolling = () => {
  //     clearInterval(interval); // prevent duplicate intervals
  //     interval = setInterval(() => fetchTableData({ silent: true }), 60_000); // ✅ 60s
  //   };

  //   const handleVisibility = () => {
  //     if (document.visibilityState === "visible") {
  //       fetchTableData({ silent: true });
  //       startPolling();
  //     } else {
  //       clearInterval(interval); // ✅ stops when tab hidden
  //     }
  //   };

  //   document.addEventListener("visibilitychange", handleVisibility);
  //   startPolling();

  //   return () => {
  //     clearInterval(interval);
  //     document.removeEventListener("visibilitychange", handleVisibility);
  //   };
  // }, [fetchTableData]);



  useEffect(() => {
    const fetchData = async () => {
      try {
        setIsLoading(true);
        const response = await getMCTTable();
        setIsTableVisible(true);
        setMctData(response.data);
        setFilteredList(response.data);
        
      } catch (error) {
        handleToastOpen("error", error.message);
      } finally {
        setIsLoading(false);
      }
    };

    fetchData();
  }, []);

const handleBulkEmailUpload = async () => {
  setIsUploading(true);
  try {
    if (!selectedBulkFile) {
      handleToastOpen("error", "File is missing");
      return;
    }
    const response = await uploadBulkEmailRequests(selectedBulkFile);
    if (response?.data?.insertedNames && response.data.insertedNames > 0) {
      handleToastOpen(
        "success",
        `${response.data.insertedNames} records inserted successfully`,
      );
      setSelectedBulkFile(null);
      setIsTableVisible(true);
    } else {
      handleToastOpen(
        "error",
        "Data Upload Unsuccessful (All Duplicates Found)",
      );
    }
  } catch (error) {
    handleToastOpen(
      "error",
      error.response?.data?.message || "File upload failed",
    );
  } finally {
    setIsUploading(false); // ← UI unblocks immediately
  }

  // ── Silent background refresh — no loader shown ───────────────────
  // await fetchTableData({ silent: true }; // ← silent = true, no isLoading
  // ─────────────────────────────────────────────────────────────────
};



  const handleInputChange = (itemId) => (value) => {
    setEmailFieldsForm((prevSelected) => {
      const itemObject = prevSelected[itemId];
      const updatedItemObject = {
        ...itemObject,
        value: value,
      };
      return {
        ...prevSelected,
        [itemId]: updatedItemObject,
      };
    });
  };

  

  // Function to reset the email fields form
  const resetEmailFieldsForm = () => {
    setEmailFieldsForm({
      material_number: {
        enter: "Material Number",
        isRequired: true,
      },
      description: {
        enter: "Description",
      },
      reason: {
        enter: "Reason",
        isRequired: true,
      },
      type_of_request: {
        enter: "Type of Request",
        isRequired: true,
        dropdownValues: [
          CREATE_TYPE,
          EXTEND_TYPE,
          COPY_TYPE,
          MODIFY_TYPE,
          DELETE_TYPE,
          MPN_TYPE,
        ],
      },
      plant_code: {
        enter: "Plant Id",
        isRequired: true,
      },
      mdm_name: {
        enter: "MDM Name",
        isRequired: true,
        value: userName,
      },
      status: {
        enter: "Status",
        dropdownValues: ["Approved", "Rejected"],
      },
      rejected_request_comments: {
        enter: "Rejected Request Comments",
      },
      date: {
        enter: "Date",
        isRequired: true,
        value: "",
      },
    });
  };

  const handleEmailSubmit = async () => {
    let isError = false;
    const newInput = {};
    for (const key in emailFieldsForm) {
      const item = emailFieldsForm[key];
      if (
        item.isRequired &&
        (item.value === undefined ||
          item.value === "" ||
          item.value.trim() === "")
      ) {
        handleToastOpen(
          "error",
          `Field "${item.enter}" is required but the value is blank.`,
        );
        isError = true;
        break;
      }
      newInput[key] = item.value;
    }
    if (!isError) {
      setIsEmailSubmitting(true);
      try {
        await addEmailRequest(newInput);
        setIsTableVisible(true);
        handleToastOpen("success", "Data Successfully Inserted");
        resetEmailFieldsForm();
      } catch (error) {
        handleToastOpen("error", "No Data Found");
      } finally {
        setIsEmailSubmitting(false);
      }
    }
  };

  const downloadExportFile = async () => {
    try {
      const response = await getDownloadExportFile();
      const blob = new Blob([response.data]);
      const link = document.createElement("a");
      link.href = window.URL.createObjectURL(blob);
      link.download = `MaterialRequestData_${formattedDate}.xlsx`;
      document.body.appendChild(link);
      link.click();
      document.body.removeChild(link);
      handleToastOpen("success", "File Downloaded Successfully");
    } catch (error) {
      handleToastOpen("error", "File download Unsuccessful");
    }
  };

  const setFilteredData = (updatedSelectedStatus, searchValue) => {
    let filteredData = [...mctData];
    Object.keys(updatedSelectedStatus).forEach((key) => {
      const value = updatedSelectedStatus[key];
      if (value === null || value === "") {
        filteredData = filteredData.filter((item) => true);
      } else {
        filteredData = filteredData.filter((item) => item[key] === value);
      }
    });
    if (searchValue !== "") {
      const searchArr = [
        "material_number",
        "description",
        "plant_code",
        "uuid",
      ];
      const filteredResult = filteredData.filter((rowVal) => {
        return searchArr.some((key) => {
          return rowVal[key] === searchValue;
        });
      });
      if (filteredResult.length > 0) {
        setFilteredList(filteredResult);
      } else {
        setFilteredList(filteredData);
      }
    } else {
      setFilteredList(filteredData);
    }
  };

  const searchItems = (searchValue) => {
    setSearchValue(searchValue);
  };

  const onSearchClick = () => {
    setFilteredData(selectedStatus, searchValue);
  };

  const handleStatusChange = (rowName, selectedValue) => {
    const updatedSelectedStatus = { ...selectedStatus };
    updatedSelectedStatus[rowName] = selectedValue;
    setSelectedStatus(updatedSelectedStatus);
    setFilteredData(updatedSelectedStatus, searchValue);
  };

  const handleEmailBulkFileDownload = async () => {
    setEmailBulkLoading(true);
    try {
      const response = await getSampleUploadFile("email_bulk_upload");
      const blob = new Blob([response.data]);
      const link = document.createElement("a");
      link.href = window.URL.createObjectURL(blob);
      link.download = `Email_Request_Sample.csv`;
      document.body.appendChild(link);
      link.click();
      document.body.removeChild(link);
      handleToastOpen("success", "File Downloaded Successfully");
    } catch (error) {
      handleToastOpen("error", "File download Unsuccessful");
    } finally {
      setEmailBulkLoading(false);
    }
  };

  const handleRequestSampleUpload = async () => {
    // setEmailBulkLoading(true);
    try {
      const response = await getSampleUploadFile("request_bulk_upload");
      const blob = new Blob([response.data]);
      const link = document.createElement("a");
      link.href = window.URL.createObjectURL(blob);
      link.download = `SampleRequestBulkUpload.xlsx`;
      document.body.appendChild(link);
      link.click();
      document.body.removeChild(link);
      handleToastOpen("success", "File Downloaded Successfully");
    } catch (error) {
      handleToastOpen("error", "File download Unsuccessful");
    }
    // } finally {
    //   setEmailBulkLoading(false);
    // }
  };

  // New handler for bulk creation sample file download
  const handleBulkCreationFileDownload = async () => {
    setBulkCreationLoading(true);
    try {
      const response = await getSampleUploadFile("bulk_creation_upload");
      const blob = new Blob([response.data]);
      const link = document.createElement("a");
      link.href = window.URL.createObjectURL(blob);
      link.download = `Bulk_Creation_Sample.xlsx`;
      document.body.appendChild(link);
      link.click();
      document.body.removeChild(link);
      handleToastOpen("success", "File Downloaded Successfully");
    } catch (error) {
      handleToastOpen("error", "File download Unsuccessful");
    } finally {
      setBulkCreationLoading(false);
    }
  };

  return {
    handleFileChoose,
    handleBulkFile,
    handleUpload,
    handleBulkEmailUpload,
    emailFieldsForm,
    handleInputChange,
    handleEmailSubmit,
    isEmailSubmitting,
    downloadExportFile,
    searchItems,
    onSearchClick,
    handleStatusChange,
    isTableVisible,
    filteredList,
    isUploading,
    isLoading,
    handleEmailBulkFileDownload,
    handleBulkCreationFileDownload, // Added new handler to return object
    emailBulkLoading,
    bulkCreationLoading,
    handleRequestSampleUpload,
    setIsLoading,
    isUploadSubmitting,
    mctData,
  };
};

export default MatRequestVM;
